import { Card, Field } from '../../../components/ui';
import { ORDER_LABEL, REJECT_STYLE_LABEL, type CardProps } from './defaults';
import type { BannerAppearance } from '../../../lib/api';

type Buttons = BannerAppearance['buttons'];

export default function ButtonsCard({ a, update, readOnly }: CardProps) {
  const b = a.buttons;
  const set = (patch: Partial<Buttons>) => update((x) => ({ ...x, buttons: { ...x.buttons, ...patch } }));
  const none = !b.acceptAll && !b.rejectAll && !b.customise;

  return (
    <Card title="Buttons">
      <div className="check-list">
        <label className="ck-check">
          <input
            type="checkbox" checked={b.acceptAll} disabled={readOnly}
            onChange={(e) => set(e.target.checked ? { acceptAll: true, rejectAll: true } : { acceptAll: false })}
          />
          Accept all
        </label>
        <label className="ck-check">
          <input type="checkbox" checked={b.rejectAll} disabled={readOnly || b.acceptAll} onChange={(e) => set({ rejectAll: e.target.checked })} />
          Reject all
        </label>
        {b.acceptAll && (
          <div className="help" style={{ marginTop: -2, marginLeft: 24 }}>
            Reject all stays while Accept all is shown: refusal must be as easy as acceptance. The two share one row and one size.
          </div>
        )}
        <label className="ck-check">
          <input type="checkbox" checked={b.customise} disabled={readOnly} onChange={(e) => set({ customise: e.target.checked })} />
          Customise
        </label>
      </div>
      {none && <div className="note bad" style={{ marginTop: 10 }}>At least one button is needed.</div>}
      <div className="row" style={{ marginTop: 14 }}>
        <Field label="Refusal wording">
          <select value={b.rejectStyle} disabled={readOnly || !b.rejectAll} onChange={(e) => set({ rejectStyle: e.target.value as Buttons['rejectStyle'] })}>
            {(Object.keys(REJECT_STYLE_LABEL) as Buttons['rejectStyle'][]).map((k) => <option key={k} value={k}>{REJECT_STYLE_LABEL[k]}</option>)}
          </select>
        </Field>
        <Field label="Order">
          <select value={b.order} disabled={readOnly} onChange={(e) => set({ order: e.target.value as Buttons['order'] })}>
            {(Object.keys(ORDER_LABEL) as Buttons['order'][]).map((k) => <option key={k} value={k}>{ORDER_LABEL[k]}</option>)}
          </select>
        </Field>
      </div>
    </Card>
  );
}
